import "@fortawesome/fontawesome-free/css/all.min.css";
import React, { useState } from "react";
import "./App.css";
import DecisionTree from "./components/DecisionTree";

const App = () => {
 return (
    <div style={{ maxWidth: "400px", margin: "0 auto" }}>
      <DecisionTree />
    </div>
  );
};

export default App;
